import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-unauthorised',
  templateUrl: './unauthorised.component.html',
  styleUrls: ['./unauthorised.component.css']
})
export class UnauthorisedComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/auth/unauthorised/unauthorised.component.ts